/*
 * escapeHtml.js
 */

const matchHtmlRegExp = /["'&<>]/;

/**
 * Escapes special HTML characters.
 *
 * Based on:
 * https://github.com/component/escape-html
 *
 * @param   {string} str - string to escape.
 * @returns {string} escaped HTML.
 */
export default function escapeHtml(str) {

  str = String(str);

  const match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  let esc;
  let html = '';
  let index = 0;
  let lastIndex = 0;

  for (index = match.index; index < str.length; index++) {

    switch (str.charCodeAt(index)) {

      case 34: // "
        esc = '&quot;';
        break;

      case 38: // &
        esc = '&amp;';
        break;

      case 39: // '
        esc = '&#39;';
        break;

      case 60: // <
        esc = '&lt;';
        break;

      case 62: // >
        esc = '&gt;';
        break;

      default:
        continue;

    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += esc;

  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;

}
